class State {
  id: number;
  abbr: string;
  active: number;
  state: string;
  created_at: string;
  updated_at: string;

  constructor(data: any) {
    this.id = data.id;
    this.abbr = data.abbr;
    this.active = data.active;
    this.state = data.state;
    this.created_at = data.created_at;
    this.updated_at = data.updated_at;
  }
}

export { State };